/**
 * What makes a meeting a meal. Two ways, one flag:
 *  - a person logged it as "Lunch / coffee" (activities.metadata.meal = true), or
 *  - calendar sync wrote it and its subject names a meal. Caleb accepted
 *    (2026-09-29) that "Lunch & Learn" counts.
 * The title rule applies to calendar rows only: a hand-logged meeting is a meal
 * only when someone said so. server/mealBoundary.test.ts keeps this the one list.
 */
export const MEAL_KEYWORDS = ["lunch", "breakfast", "dinner", "coffee"] as const;
export const MEAL_LABEL = "Lunch / coffee";

const MEAL_RE = new RegExp(`\\b(${MEAL_KEYWORDS.join("|")})`, "i");

/** Word-start match, any case: "Lunch & Learn" yes, "Launch" and "Afterlunch" no. */
export function isMealTitle(title: string | null | undefined): boolean {
  return MEAL_RE.test(title ?? "");
}

/** The same rule for Postgres `~*`; `\m` is its word-start anchor. */
export const MEAL_TITLE_PG_REGEX = `\\m(${MEAL_KEYWORDS.join("|")})`;
